module.exports = __webpack_public_path__ + "static/HDBR-Cotidiano-5-9f751c9a52c36bbf8647fcd1c0ed666c.jpg";